import { z } from 'zod';

/**
 * Common zod primitives shared across identity, tenancy, and audit schemas.
 * Keep this list narrow — anything tenant- or addon-specific belongs in its
 * own module, not here.
 */

export const UuidSchema = z.string().uuid();

/**
 * DNS-safe subdomain slug.
 * - 2..63 chars (DNS label max)
 * - starts and ends with [a-z0-9]
 * - internal chars [a-z0-9-]
 */
export const SlugSchema = z
  .string()
  .min(2)
  .max(63)
  .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/);

/**
 * The supported languages.
 * Decision: specs/DECISION_LANGUAGE_REDUCTION_2026-04-27.md (supersedes D8).
 * Keep this tuple in sync with `SUPPORTED_LANGUAGES` in `@sazeo/i18n`.
 */
export const LangCodeSchema = z.enum(['ka', 'en', 'ru', 'az', 'tr', 'uk']);

export type LangCode = z.infer<typeof LangCodeSchema>;

/** ISO-8601 timestamp with an explicit offset (e.g. `2026-04-21T12:00:00+00:00`). */
export const TimestampSchema = z.string().datetime({ offset: true });

export const EmailSchema = z.string().email();
